import './index.css'

const UserProfile = props => {
  const {lis} = props

  return (
    <div className="userdiv">
      <img className="profile" alt="profile" src={lis.profileImageUrl} />
      <h1>{lis.name}</h1>
      <p>{lis.shortBio}</p>
    </div>
  )
}

export default UserProfile
